import styled from "@emotion/styled";
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { ErrorText } from "../assets/globalStyles";

export { ErrorText };

export const FormCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 480px;
  padding: 0 16px;
  box-sizing: border-box;

  & .MuiTextField-root .MuiOutlinedInput-root {
    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);
    background-color: ${({ theme }) =>
      theme.palette.mode === "light"
        ? "rgba(255, 255, 255, 0.7)"
        : "rgba(18, 18, 18, 0.7)"};
  }
`;

export const AuthTitle = styled.h1`
  font-size: 26px;
  font-family: "MontserratMed";
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
  margin: 0 0 8px 0;
`;

export const AuthSubtitle = styled.p`
  font-size: 16px;
  font-family: "MontserratMed";
  color: ${({ theme }) => theme.palette.text.secondary};
  margin: 0 0 20px 0;
  text-align: center;
`;

export const TextLink = styled.button`
  font-family: "MontserratMed";
  font-size: 16px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 4px 0;
  margin: 4px 0;
  color: ${({ theme }) =>
    theme.palette.mode === "light"
      ? theme.palette.secondary.main
      : theme.palette.primary.main};

  &:hover {
    color: ${({ theme }) =>
      theme.palette.mode === "light"
        ? theme.palette.secondary.dark
        : theme.palette.primary.dark};
  }

  &:focus-visible {
    outline: 2px solid
      ${({ theme }) =>
        theme.palette.mode === "light"
          ? theme.palette.secondary.main
          : theme.palette.primary.main};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const PasswordRequirementsList = styled(List)({
  width: "100%",
  padding: 0,
  margin: "8px 0 16px 0",
});

export const RequirementItem = styled(ListItem)({
  padding: "2px 0",
  minHeight: "auto",
});

export const RequirementIcon = styled(ListItemIcon)({
  minWidth: "30px",
});

export const RequirementText = styled(ListItemText)(({ theme }) => ({
  margin: 0,
  "& .MuiListItemText-primary": {
    fontSize: "0.875rem",
    color: theme.palette.text.secondary,
  },
}));
